import { render, staticRenderFns } from "./RegistrationComponent.vue?vue&type=template&id=51b85493&scoped=true&"
import script from "./RegistrationComponent.vue?vue&type=script&lang=ts&"
export * from "./RegistrationComponent.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationComponent.vue?vue&type=style&index=0&id=51b85493&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b85493",
  null
  
)

export default component.exports